import React from 'react'
import {
  FormDashboardLabel as Label,
  ButtonOutline
} from '.'

const ImagePickerSidebar = ({className, label, height, message, buttonWidth}) => {
  const fileInput = React.useRef()
  const [image, setImage] = React.useState(undefined)

  const handleChange = (e) => {
    console.log(e)
    setImage(URL.createObjectURL(e.target.files[0]))
  }

  return (
    <div className={`${className}`}>
      {
        label &&
        <Label>{label}</Label>
      }
      <div
        className="border border-dashed mb-4 rounded flex justify-center items-center bg-center bg-no-repeat bg-cover cursor-pointer"
        onClick={() => fileInput.current.click()}
        style={{
          borderColor: '#ddd', height: height ? height : '128px',
          backgroundImage: image ? `url('${image}')` : '',
        }}
      >
        <input type="file" className="hide hidden" onChange={handleChange} ref={fileInput}/>
        {
          !image &&
          <div className="text-center">
            {
              message &&
              <p className="text-xs text-gray-999 mb-3">{message}</p>
            }
            <ButtonOutline style={{width: buttonWidth ? buttonWidth : '100%', minWidth: '120px', maxWidth: '160px'}}>
              Choose File
            </ButtonOutline>
          </div>
        }
      </div>
    </div>
  )
}

export { ImagePickerSidebar }